export default __webpack_public_path__ + "static/media/pending-icon.be4aa539.svg";